import { createAtomObserver } from '@exodus/atoms';
const createOptimisticBalancesPlugin = ({ optimisticBalances, optimisticBalancesAtom, port, balancesAtom, config: { enabled }, }) => {
    const observer = createAtomObserver({
        atom: enabled && optimisticBalancesAtom ? optimisticBalancesAtom : balancesAtom,
        port,
        event: 'optimisticBalances',
    });
    const onStart = () => {
        if (enabled) {
            optimisticBalances?.load();
        }
    };
    const onLoad = () => {
        observer.start();
    };
    const onStop = () => {
        observer.unregister();
        if (!enabled)
            return;
        optimisticBalances?.stop();
    };
    const onClear = async () => {
        if (!enabled)
            return;
        await optimisticBalancesAtom?.set(undefined);
    };
    return {
        onStart,
        onLoad,
        onStop,
        onClear,
    };
};
const optimisticBalancesPluginDefinition = {
    id: 'optimisticBalancesPlugin',
    type: 'plugin',
    factory: createOptimisticBalancesPlugin,
    dependencies: [
        'optimisticBalances?',
        'optimisticBalancesAtom?',
        'balancesAtom',
        'port',
        'config',
    ],
    public: true,
};
export default optimisticBalancesPluginDefinition;
